import { z } from 'zod';

export const schemaConsorsZipcode = z
    .string()
    .min(4)
    .max(5)
    .refine(
        (val) => {
            return /^[0-9]+$/.test(val);
        },
        { message: 'Invalid characters' },
    );

export type SchemaConsorsZipcode = z.infer<typeof schemaConsorsZipcode>;
